import React, { useState, useCallback, useEffect } from "react";
import UploadField from "./UploadField";
import { getUploadField, getUploadFieldConfig, uploadFile } from "./api";
const UploadFieldContainer = ({
  enableRemoval = false,
  fileId = void 0,
  onUpdate,
  accept = void 0,
  setDisableFormSubmission
}) => {
  const [isLoading, setIsLoading] = useState(!!fileId);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadConfig, setUploadConfig] = useState();
  const [uploadSuccessful, setUploadSuccessful] = useState();
  const [currentFile, setCurrentFile] = useState();
  useEffect(() => {
    if (!fileId || !isLoading) {
      return;
    }
    getUploadField(fileId).then((response) => {
      setCurrentFile({
        id: fileId,
        name: response.file_name
      });
    }).finally(() => {
      setIsLoading(false);
    });
  }, [fileId, isLoading]);
  useEffect(() => {
    getUploadFieldConfig().then((response) => {
      setUploadConfig({
        maxUploadSize: response.max_file_size_bytes
      });
    });
  }, []);
  const onDeleteFile = useCallback(() => {
    setCurrentFile(void 0);
    onUpdate(void 0);
  }, [onUpdate]);
  const onUploadFile = useCallback(
    (files) => {
      if (currentFile) {
        onDeleteFile();
      }
      setIsUploading(true);
      setDisableFormSubmission(true);
      uploadFile(files[0]).then((response) => {
        const { id, file_name: name } = response;
        setCurrentFile({
          id,
          name
        });
        onUpdate(id);
        setUploadSuccessful(true);
      }).catch(() => {
        setUploadSuccessful(false);
      }).finally(() => {
        setIsUploading(false);
        setDisableFormSubmission(false);
      });
    },
    [currentFile, onDeleteFile, onUpdate, setDisableFormSubmission]
  );
  return /* @__PURE__ */ React.createElement(
    UploadField,
    {
      accept,
      uploadSuccessful,
      currentFile,
      enableRemoval,
      isLoading,
      isUploading,
      uploadConfig,
      onUploadFile,
      onDeleteFile
    }
  );
};
export default UploadFieldContainer;
